// ** React
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'

// ** Global
import './index.css'
import './i18n'

// ** Third
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import theme from './theme'
import { RecoilRoot } from 'recoil'
import { ReactFlowProvider } from 'reactflow' // ReactFlowProvider를 추가

// ** New Page
import Home from './pages/Home'
import User from './pages/admin/User'
import AdminCommunity from './pages/admin/Community'
import AdminQnA from './pages/admin/QnA'
import SignIn from './pages/SignIn'
import SignUp from './pages/SignUp'
import MyPage from './pages/MyPage'
import Sample from './pages/Sample'
import AuctionCases from './pages/AuctionCases'
import Assets from './pages/Assets'
import Community from './pages/Community'
import CommunityDetail from './pages/CommunityDetail'
import QnA from './pages/QnA'
import QnADetail from './pages/QnADetail'
import Notice from './pages/Notice'
import NoticeDetail from './pages/NoticeDetail'
import FAQ from './pages/FAQ'
import Introduction from './pages/Introduction'
import BusinessIntroduction from './pages/BusinessIntroduction'
import AdminNotice from './pages/admin/Notice'
import AdminAsset from './pages/admin/Asset'
import AdminAuctionCase from './pages/admin/AuctionCase'

const router = createBrowserRouter([
  { path: '/', element: <Home /> }, // 홈
  { path: '/signIn', element: <SignIn /> }, // 로그인
  { path: '/signUp', element: <SignUp /> }, // 회원가입
  { path: '/mypage', element: <MyPage /> }, // 마이페이지
  { path: '/sample', element: <Sample /> }, // 샘플
  
  // 메뉴
  { path: '/introduction', element: <Introduction /> }, // 회사소개
  { path: '/business-introduction', element: <BusinessIntroduction /> }, // 사업소개
  { path: '/auction-cases', element: <AuctionCases /> }, // 경매 사례
  { path: '/assets', element: <Assets /> }, // 자산
  { path: '/community', element: <Community /> }, // 커뮤니티
  { path: '/community/:id', element: <CommunityDetail /> }, // 커뮤니티 상세
  { path: '/qna', element: <QnA /> }, // Q&A
  { path: '/qna/:id', element: <QnADetail /> }, // Q&A 상세
  { path: '/notice', element: <Notice /> }, // 공지사항
  { path: '/notice/:id', element: <NoticeDetail /> }, // 공지사항 상세
  { path: '/faq', element: <FAQ /> }, // FAQ
  
  // 관리자
  { path: '/admin/user', element: <User /> },
  { path: '/admin/community', element: <AdminCommunity /> },
  { path: '/admin/qna', element: <AdminQnA /> },
  { path: '/admin/notice', element: <AdminNotice /> },
  { path: '/admin/asset', element: <AdminAsset /> },
  { path: '/admin/auction-case', element: <AdminAuctionCase /> },
  
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <ChakraProvider theme={theme}>
    <RecoilRoot>
      <ReactFlowProvider>
        <RouterProvider router={router} />
      </ReactFlowProvider>
    </RecoilRoot>
  </ChakraProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
